(function () {
  if (window.__nuraVariantPopup) return;
  window.__nuraVariantPopup = true;

  var openPopup = null;
  var openerEl = null;

  function openIt(opener) {
    var popup = document.getElementById(opener.getAttribute('data-nura-vp-open'));
    if (!popup) return;
    if (popup.parentNode !== document.body) document.body.appendChild(popup);
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('nura-vp-lock');
    openPopup = popup;
    openerEl = opener;
    var first = popup.querySelector('.nura-vp__option:not([disabled])');
    if (first) first.focus();
  }

  function closeIt(returnFocus) {
    if (!openPopup) return;
    openPopup.classList.remove('is-open');
    openPopup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('nura-vp-lock');
    var opener = openerEl;
    openPopup = null;
    openerEl = null;
    if (returnFocus && opener && opener.focus) opener.focus();
  }

  function choose(option) {
    var popup = option.closest('.nura-vp');
    if (!popup) return;
    var form = popup.querySelector('form');
    if (!form) return;
    var input = form.querySelector('[name=id]');
    var submit = form.querySelector('[type=submit]');
    if (!input || !submit) return;
    input.value = option.getAttribute('data-variant-id');
    input.disabled = false;
    submit.click();
    closeIt(false);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-nura-vp-open]');
    if (opener) {
      e.preventDefault();
      openIt(opener);
      return;
    }
    var option = e.target.closest('.nura-vp__option');
    if (option) {
      e.preventDefault();
      if (!option.disabled) choose(option);
      return;
    }
    if (e.target.closest('[data-nura-vp-close]')) {
      e.preventDefault();
      closeIt(true);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openPopup) closeIt(true);
  });
})();
